import React, { useState, useEffect, useContext } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "axios";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconForwardArrow from "../../assets/images/IconForwardArrow.png";
import IconRightYellow from "../../assets/images/IconRightYellow.png";
import IconLeftYellow from "../../assets/images/IconLeftYellow.png";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconSearch13 from "../../assets/images/IconSearch13.png";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import RefreshToken from "../../components/RefreshToken";
import { TransferContext } from "../../context/TransferContext";

const useStyles = makeStyles((theme) => ({
  marginBottomStyle: {
    marginBottom: "20px",
  },

  rightAlign: {
    textAlign: "right",
  },

  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
      borderRadius: "8px",
      backgroundColor: "#fff",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
      borderRadius: "8px",
      backgroundColor: "#fff",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: "14px",
    },
  },
  textField2: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: "14px 14px 14px 2px",
    },
  },
  backgroundStyle: {
    background: "#fff",
    borderRadius: "8px",
  },

  tableContainerStyle: {
    background: "white",
    padding: "10px 20px",
    borderRadius: "4px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  tableStyle: {
    "& tbody tr:hover": {
      background: "#FCF1EC",
      borderRadius: "8px",
      cursor: "pointer",
      padding: 10,
    },
    "& th": {
      color: "#19181666",
      // padding:0,
    },
    "& td": {
      // borderBottom: "none !important",
      // padding:0
      // padding: "0px 24px 6px 16px",
    },
    "& tr:last-child td": {
      borderBottom: "none !important",
    },
  },
  pageNoStyle: {
    background: "#9c3836",
    padding: "5px 10px",
    margin: "0 22px",
    cursor: "pointer",
    borderRadius: "8px",
  },
  pageNoImageStyle: {
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "8px",
  },
}));

const Transactions = () => {
  const classes = useStyles();
  let history = useHistory();
  const [transactionType, setTransactionType] = useState(0);
  const [status, setStatus] = useState(0);
  const [transactions, setTransactions] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { removeTransfer } = useContext(TransferContext);


  const getTransaction = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: `/api/v1/private/agent/transaction?page=${page}`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", res.data.data);

      setTransactions(res.data.data.content);
      setPage(res.data.data.pageable.pageNumber);
      setTotalRows(res.data.data.totalElements);
      setRowsPerPage(res.data.data.pageable.pageSize);
    } catch (error) {
      console.log("err:::", error.response);
    }
    setLoading(false);
  };

  const handleChangePage = async (event, newPage) => {
    console.log("new page", newPage);
    setPage(newPage);
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
  };
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  function goToDtailsPage(item) {
    history.push({ pathname: "/transaction-details", state: item });
  }

  useEffect(() => {
    removeTransfer({});

    getTransaction();
    console.log("changes");
  }, [page]);

  return (
    <div>
      <Typography variant="h5" className={classes.marginBottomStyle}>
        Transaction History
      </Typography>
      {/* <Grid container spacing={2} className={classes.marginBottomStyle}>
        <Grid item xs={4}>
          <FormControl
            fullWidth
            size="small"
            variant="outlined"
            className={classes.backgroundStyle}
          >
            <OutlinedInput
              id="outlined-adornment-amount"
              className={classes.textField2}
              startAdornment={
                <InputAdornment position="start">
                  <img src={IconSearch13} alt="" />
                </InputAdornment>
              }
              placeholder="Describe your issues"
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField
            id="date"
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            defaultValue="2017-05-24"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={5}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl
                size="small"
                fullWidth
                className={classes.marginTop10}
                variant="outlined"
              >
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={transactionType}
                  onChange={handleTransactionTypeChange}
                  className={classes.inputStyle2}
                >
                  <MenuItem disabled value={0}>
                    <span style={{ color: "#999" }}>Transaction Type</span>
                  </MenuItem>
                  <MenuItem value={10}>Bank</MenuItem>
                  <MenuItem value={20}>MFC</MenuItem>
                  <MenuItem value={30}>Cash Pickup</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                size="small"
                fullWidth
                className={classes.marginTop10}
                variant="outlined"
              >
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={status}
                  onChange={handleStatusChange}
                  className={classes.inputStyle2}
                >
                  <MenuItem disabled value={0}>
                    <span style={{ color: "#999" }}>Status</span>
                  </MenuItem>
                  <MenuItem value={10}>Delivered</MenuItem>
                  <MenuItem value={20}>Processing</MenuItem>
                  <MenuItem value={30}>On Hold</MenuItem>
                  <MenuItem value={40}>Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}
      <TableContainer
        className={`${classes.tableContainerStyle} ${classes.marginBottomStyle}`}
      >
        <Table className={classes.tableStyle} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell> Date</TableCell>
              <TableCell>Transaction ID</TableCell>
              <TableCell>Collection Point</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          {
            !loading && <TableBody>
            {transactions.map((item, index) => (
              <TableRow onClick={(e) => goToDtailsPage(item)} key={index}>
                <TableCell>
                  {moment(item.createdAt).format("DD MMMM YYYY")}
                </TableCell>
                <TableCell>{item.transactionNumber}</TableCell>
                <TableCell>{item.collectionPoint}</TableCell>
                <TableCell>
                  {item.transaction &&
                    item.transaction.amountToTransfer.toFixed(2)}
                  <strong style={{ marginLeft: 5 }}>
                    {item.transaction && item.transaction.fromCurrency}
                  </strong>
                </TableCell>
                <TableCell>
                  <img src={IconForwardArrow} alt="" />
                </TableCell>
                <TableCell>
                  {item.transaction &&
                    item.transaction.amountReceivable.toFixed(2)}
                  <strong style={{ marginLeft: 5 }}>
                    {item.transaction && item.transaction.toCurrency}
                  </strong>
                </TableCell>
                <TableCell>{item.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          }
          <TableBody>
            <TableRow>
              <TableCell colSpan={7} style={{ textAlign: "center" }}>
                {loading ? (
                  <>
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                  </>
                ) : null}
                {!loading && transactions.length < 1 && " No record Found"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Grid container justifyContent="flex-end" spacing={3}>
        <Grid item className={classes.rightAlign}>
          1-10 of 96
        </Grid>
        <Grid item className={classes.rightAlign}>
          <span className={classes.pageNoImageStyle}>
            <img src={IconLeftYellow} alt="" />
          </span>
          <span className={classes.pageNoStyle}>1</span>
          <span className={classes.pageNoImageStyle}>
            <img src={IconRightYellow} alt="" />
          </span>
        </Grid>
      </Grid> */}
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onChangePage={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10]}
      />
      {/* <span className={classes.pageNoStyle}>{page}</span> */}
    </div>
  );
};

export default Transactions;
